import { Howl } from "howler";
import osLogo from "../static/img/riviaos-icon.png";

let globalNotificationHandler = null;

export const setGlobalNotificationHandler = (handler) => {
  globalNotificationHandler = handler;
};

export const clearGlobalNotificationHandler = () => {
  globalNotificationHandler = null;
};

const playFallbackBeep = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) {
      return;
    }
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = 880;
    gain.gain.value = 0.12;
    osc.start();
    osc.stop(ctx.currentTime + 0.25);
  } catch {
    // ignore
  }
};

export const playNotificationSound = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    new Howl({
      src: [`${process.env.PUBLIC_URL || ""}/bell-2.wav`],
      autoplay: true,
      volume: 0.5,
      onloaderror: playFallbackBeep,
      onplayerror: playFallbackBeep,
    });
  } catch {
    playFallbackBeep();
  }
};

export const requestNotificationPermission = async () => {
  if (typeof window === "undefined" || !("Notification" in window)) {
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission === "denied") {
    return false;
  }

  const permission = await Notification.requestPermission();
  return permission === "granted";
};

/**
 * @param {{ title: string, body: string, tag?: string, variant?: 'success'|'danger', data?: object }} data
 */
export const showSocketNotification = async (data) => {
  if (typeof window === "undefined") {
    return;
  }

  if (globalNotificationHandler) {
    globalNotificationHandler(data);
  }

  playNotificationSound();

  if (!("Notification" in window)) {
    return;
  }

  if (Notification.permission !== "granted") {
    const hasPermission = await requestNotificationPermission();
    if (!hasPermission) {
      return;
    }
  }

  const notification = new Notification(data.title, {
    body: data.body,
    icon: osLogo,
    badge: osLogo,
    tag: data.tag,
    data: data.data,
    requireInteraction: true,
    silent: false,
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
    if (data.data?.url) {
      window.location.href = data.data.url;
    }
  };
};
